<template>
  <div class="padBSM padTSM pf23-lineBtm">

    <!--  파일 업로드 버튼 Label -->    
    <label :for="`file${resIdx}_${question.sq_code}`" class="fntP pf23-inFo-file">
      <em class="disIb">{{ question.title }} <span class="ico-must-astar"></span></em>
      <div class="pf12-familyWidth txtR">
        <span class="pf23-fileBtn">파일 업로드</span>
      </div>
    </label>

    <div class="pf12-familyWidth">
      <!--  파일 업로드 버튼 -->
      <input
        v-if="!existFileData"
        type="file"
        ref="attachment"
        accept=".png, .jpg, .pdf"
        :name="`file${resIdx}_${question.sq_code}`"
        :id="`file${resIdx}_${question.sq_code}`"
        style="display:none; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width:55%;"
        @change="uploadAttachment"
        :disabled="disabled"
      />

      <!-- 업로드된 파일 정보 표시 영역 -->
      <div class="posRe">
        <label class="pf23-inFo-file marTS pf23-fileInput" @click="downloadFile">
          <input
            type="text"
            :title="originalName"
            :value="originalName"
            :style="existFileData ? { cursor: 'pointer' } : null"
            readonly
          />
        </label>

        <!-- 삭제 버튼 -->
        <button
          class="posAb"
          style="right:0; top:6px; background:none;"
          :style="!existFileData || disabled ? { display: 'none' } : null"
          @click="deleteAttachment"          
        >
          <img src="../images/btn_close.png" alt="파일 삭제 버튼">
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { AttachmentMixin } from '../mixins'

export default {
  name: 'SurveyAttachmentFamily',
  mixins: [AttachmentMixin]
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyAttachmentFamily.vue